export const WomenNav = () => {
  return (
    <div
      className="ddown"
      style={{
        marginLeft: "-80px",
      }}
    >
      <a href="/women">
      <div className="flex">
        <div className="a1 w">
        
          <ul>
            <li>Indian & Fusion Wear</li>
            <li>Kurtas & Suits</li>
            <li>Kurtis, Tunics & Tops</li>
            <li>Ethnic Wear</li>
            <li>Leggings, Salwars & Churidars</li>
            <li>Skirts & Palazzos</li>
            <li>Sarees</li>
            <li>Dress Materials</li>
            <li>Lehenga Cholis</li>
            <li>Dupattas & Shawls</li>
            <li>Jackets</li>
          </ul>

          <ul className="nextul ">
            <li>Belts, Scarves & More</li>
          </ul>
          <ul className="nextul">
            <li>Watches & Wearables</li>
          </ul>
        </div>
        <div className="a2 w">
          <ul>
            <li>Western Wear</li>
            <li>Dresses</li>
            <li>Jumpsuits</li>
            <li>Tops</li>
            <li>Jeans</li>
            <li>Trousers & Capris</li>
            <li>Shorts & Skirts</li>
            <li>Shrugs</li>
            <li>Sweaters & Sweatshirts</li>
            <li>Jackets & Coats</li>
            <li>Blazers & Waistcoats</li>
          </ul>

          <ul className="nextul">
            <li>Plus Size</li>
          </ul>
          <ul className="nextul">
            <li>Sunglasses & Frames</li>
          </ul>
        </div>
        <div className="a1 w">
          <ul>
            <li>Footwear</li>
            <li>Flats</li>
            <li>Casual Shoes</li>
            <li>Heels</li>
            <li>Boots</li>
            <li>Sports Shoes & Floaters</li>
          </ul>

          <ul className="nextul">
            <li>Sports & Active Wear</li>
            <li>Clothing</li>
            <li>Footwear</li>
            <li>Sports Accessories</li>
            <li>Sports Equipment</li>
          </ul>
        </div>
        <div className="a2 w">
          <ul>
            <li>Lingerie & Sleepwear</li>
            <li>Bra</li>
            <li>Briefs</li>
            <li>Shapewear</li>
            <li>Sleepwear & Loungewear</li>
            <li>Swimwear</li>
            <li>Camisoles & Thermals</li>
          </ul>

          <ul className="nextul">
            <li>Beauty & Personal Care</li>
            <li>Makeup</li>
            <li>Skincare</li>
            <li>Premium Beauty</li>
            <li>Lipsticks</li>
            <li>Fragrances</li>
          </ul>
        </div>
        <div
          className="a1 w"
          style={{
            paddingRight: "25px",
          }}
        >
          <ul>
            <li>Gadgets</li>
            <li>Smart Wearables</li>
            <li>Fitness Gadgets</li>
            <li>Headphones</li>
            <li>Speakers</li>
          </ul>

          <ul className="nextul">
            <li>Jewellery</li>
            <li>Fashion Jewellery</li>
            <li>Fine Jewellery</li>
            <li>Earrings</li>
          </ul>
          <ul className="nextul">
            <li>Backpacks</li>
          </ul>
          <ul className="nextul">
            <li>Handbags, Bags & Wallets</li>
          </ul>
          <ul className="nextul">
            <li>Luggages & Trolleys</li>
          </ul>
        </div>
      </div>
      </a>
    </div>
  )
}